/**
 * Floating labels on forms
 */

// use gform_post_render jquery hook so these scripts work after ajax form submissions too
jQuery(document).bind('gform_post_render', function(){

  //variables
  var inputElements = document.querySelectorAll('.gform_body input, .gform_body textarea');
  var labels = document.getElementsByTagName('label');

  // assign labels to their inputs
  for (var i = 0; i < labels.length; i++) {
    if (labels[i].htmlFor != '') {
      var elem = document.getElementById(labels[i].htmlFor);
      if (elem) {
        elem.label = labels[i];
      }
    }
  }

  // add event listener to each text input, add 'floatable' classes to them, and then add/remove __floated class if input detected
  for (i = 0; i < inputElements.length; i++) {

    var currentInput = inputElements[i];

    if( (currentInput.type === 'text' && !(currentInput.value === 'Muu')) || currentInput.type === 'textarea' || currentInput.type === 'email' ) {
      currentInput.classList.add('floatable-input');

      if (currentInput.label) {
        currentInput.label.classList.add('floatable-label');
        currentInput.label.parentNode.classList.add('floatable-li');

        if ("" !== currentInput.value) {
          currentInput.label.classList.add('floatable-label__floated');
        }

        currentInput.addEventListener('input', function (e) {
          if (this.value) {
            this.label.classList.add('floatable-label__floated');
          } else {
            this.label.classList.remove('floatable-label__floated');
          }
        });
      }

    }
  }
});

var accordions = document.querySelectorAll('.js-accordion-button');
for (var k = 0; k < accordions.length; k++) {
  accordions[k].addEventListener('click', function(e) {
    e.currentTarget.classList.toggle('active');
  });
}


/**
 * Form tabs JS
 */

function supports_history_api() {
  return !!(window.history && history.pushState);
}

// @see https://stackoverflow.com/a/19472410
function replaceQueryParam(param, newval, search) {
  var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
  var query = search.replace(regex, "$1").replace(/&$/, '');
  return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
}

// if no form defined in url, open 'tilaa lehti' tab
if ( document.URL.indexOf("?form=") <= 0 && document.URL.indexOf("tilaajapalvelu") >= 0 ) {
  document.getElementsByClassName('js-select-buttons')[0].classList.add('active');
  document.getElementById('tilaa-lehti').classList.add('active');
}

(function($) {
  $('.js-select-buttons').on('click', function() {
    var $t = $(this);

    // remove active class from other tab buttons but add it to the clicked tab
    $('.js-select-buttons').removeClass('active');
    $t.toggleClass('active');

    // remove active class from other tabs content but add it to the clicked tab
    $('.available-forms .js-tab').removeClass('active');
    $($t.attr('data-target')).toggleClass('active');

    // edit url according to the tab that's open
    if (supports_history_api()) {
      var current_url = location.protocol + '//' + location.host + location.pathname;
      var form_arg = $t.attr('data-form');
      var new_url = current_url + replaceQueryParam('form', form_arg, location.search);
      new_url = replaceQueryParam('tilaus', '', new_url);
      window.history.replaceState(new_url, document.title, new_url);
    }

    sameHeights();

  });

  // $('.js-order__type').on('click', function() {

  //   var $t = $(this);

  //   // remove active class from other tab buttons but add it to the clicked tab
  //   $('.js-order__type').removeClass('active');
  //   $(this).toggleClass('active');

  //   var id = $(this).attr('data-id');
  //   $('.js-order-content').removeClass('active');
  //   $('.js-order-content[data-id="' + id + '"]').addClass('active');

  //   // edit url according to the tab that's open
  //   if (supports_history_api()) {
  //     var current_url = location.protocol + '//' + location.host + location.pathname;
  //     var form_arg = $t.attr('data-form');
  //     var id_arg = $t.attr('data-id');
  //     var new_url = current_url + replaceQueryParam('form', form_arg, location.search);
  //     new_url = replaceQueryParam('tilaus', id_arg, new_url);
  //     window.history.replaceState(new_url, document.title, new_url + '#tilaus');
  //     document.getElementById('tilaus').scrollIntoView();
  //   }

  // });

  // set .active class to the form tab that generated the confirmation message
  $(document).bind('gform_post_render', function(){
    $('.gform_confirmation_wrapper').parent().addClass('active');

  });

})(jQuery);
